import { makeStyles } from "@material-ui/core";
import { BorderBottom } from "@material-ui/icons";

export default makeStyles((theme) => ({
  dialogWrapper: {
    maxWidth: 700,
    width: "100%",
  },
  titleFiled: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    color: theme.palette.text.secondary,
    maxWidth: "280px",
    minWidth: "190px",
  },
  containerInputSection: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      width: "90vw",
    },
  },
  bannerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "20px 0",
    background: theme.palette.background.brand_50,
    border: `1px solid ${theme.palette.border.brand}`,
    borderRadius: "12px",
    padding: "16px",

    "& .MuiAlert-message": {
      width: "100%",
    },
  },
  taxWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  fieldsSection: {
    "& label": {
      minWidth: "190px",
    },
    "& .FBFieldWrapper": {
      width: "100%",
    },
    "& .text-field-wrapper > div": {
      width: "100% !important",
    },
    "& .autocomplete": {
      width: "100% !important",
    },
  },

  dropzoneSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "16px",
  },
  containerUploadedFilesCards: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  CardUploadedFilesInfo: {
    display: "flex",
    flexDirection: "row",
    padding: "16px",
    gap: "12px",
  },
  ContainerFileUploadedInfo: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  containerTitleAndDeleteIcon: {
    position: "relative",
  },
  DeleteIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0px",
    top: "0px",
  },
  TitleFileName: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "330px",
    display: "inline-block",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: theme.palette.text.secondary,
  },
  FileSizeTitle: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: theme.palette.text.tertiary,
  },
  fieldsSection: {
    "&  > * + *": {
      marginTop: "20px",
      paddingTop: "20px",
      borderTop: `1px solid ${theme.palette.border.main}`,
    },
    "& label": {
      minWidth: "190px",
    },
    "& .FBFieldWrapper": {
      width: "100%",
    },
    "& .text-field-wrapper > div": {
      width: "100% !important",
    },
    "& .autocomplete": {
      width: "100% !important",
    },
  },
  footerActions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingTop: "24px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "80px",
    },
  },
  inputField: {
    maxWidth: "100%",
  },
  textAreaInputField: {
    maxWidth: "100%",
    height: "120px",
    "& input": {
      height: "120px",
    },
  },
  textAreaInput: {
    width: "100%",
    border: `1px solid ${theme.palette.border.primary}`,
    borderRadius: "8px",
    padding: "12px",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    color: theme.palette.text.placeholder,
    resize: "none",
    background: theme.palette.background.paper,

    "&:focus": {
      borderColor: theme.palette.utility.brand_300,
      boxShadow: `0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(140, 115, 75, 0.24)`,
    },
  },
  wrapperTextArea: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "6px",
  },
}));
